var returnWrapper = function(awaitable) {
  return {
    promise: awaitable || Promise.resolve()
  };
};
export {
  returnWrapper
};
//# sourceMappingURL=return-wrapper.js.map
